/**
 * Encuentra el slot vacío más adecuado para un jugador dado.
 *
 * Algoritmo de prioridad:
 *  1. Slot vacío cuya categoría (role) coincide con la posición del jugador
 *  2. Si no hay coincidencia exacta, cualquier slot vacío disponible
 *  3. Dentro de cada nivel, elige el slot con menor índice en la formación
 *
 * @param {object} player   - jugador con { position: string }
 * @param {Array}  slots    - slots de la formación activa
 * @param {object} assignments - { [slotId]: player | null }
 * @returns {object|null}   - slot ganador o null si no hay vacante
 */
export function findBestSlot(player, slots, assignments) {
  if (!player) return null;

  const emptySlots = slots.filter((s) => !assignments[s.id]);
  if (emptySlots.length === 0) return null;

  // Prioridad 1: slot vacío cuyo role coincide con la posición del jugador
  const preferred = emptySlots.find((s) => s.role === player.position);
  if (preferred) return preferred;

  // Prioridad 2: cualquier slot vacío (sin restricción de posición)
  return emptySlots[0];
}